import React, { createContext, useContext, useState, useEffect } from 'react';

const CartContext = createContext(null);

export const useCart = () => {
  const context = useContext(CartContext);
  if (!context) {
    throw new Error('useCart must be used within CartProvider');
  }
  return context;
};

export const CartProvider = ({ children }) => {
  const [items, setItems] = useState(() => {
    const saved = localStorage.getItem('cart');
    return saved ? JSON.parse(saved) : [];
  });

  useEffect(() => {
    localStorage.setItem('cart', JSON.stringify(items));
  }, [items]);

  const addToCart = (artwork) => {
    // Check if already in cart
    if (items.some(item => item.artwork_id === artwork.id)) {
      return false;
    }
    
    const cartItem = {
      artwork_id: artwork.id,
      artwork_title: artwork.title,
      artwork_image: artwork.image_url,
      price: artwork.price,
      shipping_rate: artwork.shipping_rate || 15.0
    };
    
    setItems([...items, cartItem]);
    return true;
  };

  const removeFromCart = (artworkId) => {
    setItems(items.filter(item => item.artwork_id !== artworkId));
  };

  const clearCart = () => {
    setItems([]);
  };

  const getTotal = () => {
    return items.reduce((sum, item) => sum + item.price, 0);
  };

  return (
    <CartContext.Provider value={{
      items,
      addToCart,
      removeFromCart,
      clearCart,
      getTotal,
      itemCount: items.length
    }}>
      {children}
    </CartContext.Provider>
  );
};